import React from 'react'

import { Card, LineItem } from '@/components'
import { PropertyQueries } from '@/graphql/queries/property.queries'
import { useReservationHome } from '@/hooks'
import { useGraphql } from '@/hooks/useGraphql'
import { LeasedParkingSpots } from '@/types/Homes'
import { ReservationProperty } from '@/types/Property'
import { ReservationDetail } from '@/types/Reservation'

export function ParkingView({ reservationData }: { reservationData: ReservationDetail }) {
  const { data: propertyData } = useGraphql<{ property: ReservationProperty }>(
    PropertyQueries.QUERY_KEYS.getReservationProperty,
    PropertyQueries.getReservationProperty(),
    { id: reservationData.home.property.id },
    {
      enabled: !!reservationData,
    },
  )

  const { data: homeData } = useReservationHome({ homeId: reservationData?.home?.id })

  const leasedParkingSpots = propertyData?.property.leasedParkingSpots || []
  const homeParkingSpots = homeData?.home.leasedParkingSpots || []

  return (
    <>
      {propertyData && (
        <div>
          {propertyData?.property && (
            <Card cardClassName="mb-4">
              <div className="flex w-full flex-col px-4">
                <LineItem label="Parking Available" tag="none" value={propertyData.property.parkingAvailable} />
                <LineItem label="Paid Assigned Parking" tag="none" value={propertyData.property.paidAssigned} />
                <LineItem
                  label="First-Come, First-Served"
                  tag={propertyData.property.firstComeFirstServed ? 'success' : 'error'}
                  value={propertyData.property.firstComeFirstServed}
                />
                <LineItem
                  label="Waitlist"
                  tag={propertyData.property.waitlist ? 'success' : 'error'}
                  value={propertyData.property.waitlist}
                />
                <LineItem label="Paid Assigned Cost" tag="none" value={propertyData.property.paidAssignedCost} />
                <LineItem
                  label="Third-Party Managed"
                  tag={propertyData.property.thirdPartyManaged ? 'success' : 'error'}
                  value={propertyData.property.thirdPartyManaged}
                />
                <LineItem
                  label="Fob Required"
                  tag={propertyData.property.fobRequired ? 'success' : 'error'}
                  value={propertyData.property.fobRequired}
                />
                <LineItem
                  label="Controlled Access"
                  tag={propertyData.property.controlledAccess ? 'success' : 'error'}
                  value={propertyData.property.controlledAccess}
                />
                <LineItem
                  label="Decal Required"
                  tag={propertyData.property.decalRequired ? 'success' : 'error'}
                  value={propertyData.property.decalRequired}
                />
                <LineItem label="Notes" last={true} tag="none" value={propertyData.property.parkingNotes} />
              </div>
            </Card>
          )}
          {homeParkingSpots.length > 0 && (
            <Card cardClassName="mb-4" headerText="Available Parking for Home" minimizable={true}>
              <div className="flex w-full flex-col px-4">
                {homeParkingSpots.map((parkingSpot, index) => {
                  return <ParkingSpot index={index} {...parkingSpot} key={index} />
                })}
              </div>
            </Card>
          )}
          {leasedParkingSpots.length > 0 && (
            <Card cardClassName="mb-4" headerText="Property Parking Spots" minimizable={true}>
              <div className="flex w-full flex-col px-4">
                {leasedParkingSpots.map((parkingSpot, index) => {
                  return <ParkingSpot index={index} {...parkingSpot} key={index} />
                })}
              </div>
            </Card>
          )}
        </div>
      )}
    </>
  )
}

interface ParkingSpotProps extends LeasedParkingSpots {
  home?: { unitNumber: string }
  index: number
}

function ParkingSpot({ spotDetails, spotNumber, status, home, index }: ParkingSpotProps) {
  return (
    <div className={`flex w-full flex-col  ${index !== 0 ? 'mt-2 border-t pb-2 pt-4  border-secondary' : 'py-2'}`}>
      {home && home.unitNumber && <LineItem label="Unit Number" value={home.unitNumber} />}
      <LineItem label="Spot Number" value={spotNumber} />
      <LineItem label="Status" value={status} />
      <div className="fle-col flex w-full py-2">
        <div className="py-2 text-sm leading-140">Spot Details</div>
        <div className="py-2 text-sm leading-140">{spotDetails}</div>
      </div>
    </div>
  )
}
